import { render, staticRenderFns } from "./srPermissionRow.vue?vue&type=template&id=4e127664&scoped=true"
import script from "./srPermissionRow.vue?vue&type=script&lang=js"
export * from "./srPermissionRow.vue?vue&type=script&lang=js"
import style0 from "./srPermissionRow.vue?vue&type=style&index=0&id=4e127664&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e127664",
  null
  
)

export default component.exports